export const SEND_MAIL_FORGOT_PASSWORD_FETCH = 'SEND_MAIL_FORGOT_PASSWORD_FETCH'
export const SEND_MAIL_FORGOT_PASSWORD_SUCCESS = 'SEND_MAIL_FORGOT_PASSWORD_SUCCESS'
export const SEND_MAIL_FORGOT_PASSWORD_ERROR = 'SEND_MAIL_FORGOT_PASSWORD_ERROR'
export const SEND_MAIL_FORGOT_PASSWORD_REPEATED_EMAIL = 'SEND_MAIL_FORGOT_PASSWORD_REPEATED_EMAIL'
export const SEND_MAIL_FORGOT_PASSWORD_RESET = 'SEND_MAIL_FORGOT_PASSWORD_RESET'

export enum ForgotPasswordStatus {
  Idle,
  Loading,
  Error,
  Success,
  RepeatedEmail,
}

export interface ForgotPasswordState {
  status: ForgotPasswordStatus
  email?: string
}

export interface SendMailForgotPasswordFetch {
  type: typeof SEND_MAIL_FORGOT_PASSWORD_FETCH
  payload: {
    email: string
  }
}

export interface SendMailForgotPasswordSuccess {
  type: typeof SEND_MAIL_FORGOT_PASSWORD_SUCCESS
  payload: null
}

export interface SendMailForgotPasswordError {
  type: typeof SEND_MAIL_FORGOT_PASSWORD_ERROR
  payload: null
}

export interface SendMailForgotPasswordRepeatedEmail {
  type: typeof SEND_MAIL_FORGOT_PASSWORD_REPEATED_EMAIL
  payload: null
}

export interface SendMailForgotPasswordReset {
  type: typeof SEND_MAIL_FORGOT_PASSWORD_RESET
  payload: null
}

export const initialState: ForgotPasswordState = {
  status: ForgotPasswordStatus.Idle,
}

export type ForgotPasswordActions =
  | SendMailForgotPasswordFetch
  | SendMailForgotPasswordSuccess
  | SendMailForgotPasswordError
  | SendMailForgotPasswordRepeatedEmail
  | SendMailForgotPasswordReset
